import { editor, languages, Position, MarkerSeverity } from 'monaco-editor-core';

import { LanguageService } from '../../interface';
import { YaraModelOptions } from './interface';
import { YARA_ID } from './constants';

export class YaraLanguageService implements LanguageService {
  private static instance?: YaraLanguageService;

  static getInstance(): YaraLanguageService {
    if (!this.instance) {
      this.instance = new YaraLanguageService();
    }
    return this.instance;
  }

  // singleton
  private constructor() {}

  public registerModelOptions(model: editor.ITextModel, options: YaraModelOptions) {}

  public async doValidate(model: editor.ITextModel) {
    return true;
  }

  public parse(value: string) {
    return value;
  }
}
